'use client';

import { useLocale } from '@/i18n/context';
import { useEffect } from 'react';

/**
 * Updates document.documentElement.lang when the active locale changes.
 * Renders nothing — pure side-effect component.
 */
export function HtmlLang() {
  const { locale } = useLocale();
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);
  return null;
}
